export default {
  region: import.meta.env.VITE_AWS_REGION,
  userPoolId: import.meta.env.VITE_AWS_USERPOOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_USERPOOL_WEBCLIENT_ID,
};
